import { getCurrentEventId, } from 'redux/utils'

// ** TRIP DATA **

export const existingTripIds = state => Object.keys(state.tripData)
export const tripDataById = (state, id) => state.tripData[id]
export const selectedTripId = state => state.selectedTripId
export const selectedTripData = state => state.tripData[state.selectedTripId]
export const selectedTripMedia = state => state.tripData[state.selectedTripId].media
export const addingTrip = state => state.addingTrip
export const editingTrip = state => state.editingTrip
export const listingMode = state => state.listingMode
export const currentEventId = state => getCurrentEventId({ eventList: state.tripData[selectedTripId(state)].events, })

export const tripsList = (state) => {
  const trips = existingTripIds(state)
  return trips.map((id) => {
    const tripData = tripDataById(state, id)
    const {
      name,
      events,
    } = tripData
    const firstEvent = events[0]
    const lastEvent = events[events.length - 1]
    const startDate = firstEvent.depart || firstEvent.arrive
    const endDate = lastEvent.arrive || lastEvent.depart
    return {
      id,
      name,
      startDate,
      endDate,
    }
  })
}
// ** EVENT DATA **

export const selectedEventData = (state) => {
  const thisTripData = selectedTripData(state)
  if (!thisTripData) {
    return undefined
  }
  const selectedEvent = thisTripData.events.filter(
    event => event.id === state.selectedEventId
  )
  return selectedEvent[0]
}

export const selectedEventId = (state) => {
  return state.selectedEventId
}

export const selectedEventIndex = (state) => {
  let eventIndex = -1
  const thisTripData = selectedTripData(state)
  const eventData = selectedEventData(state)
  if (!thisTripData || !eventData) {
    return -1
  }
  thisTripData.events.forEach((event, index) => {
    if (event.id === eventData.id) {
      eventIndex = index
    }
  })
  return eventIndex
}

export const selectedEventNextEvent = (state) => {
  const thisTripData = selectedTripData(state)
  const eventIndex = selectedEventIndex(state)
  if (
    !thisTripData ||
    eventIndex === -1 ||
    !thisTripData.events[eventIndex + 1]
  ) {
    return undefined
  }
  return thisTripData.events[eventIndex + 1]
}

export const selectedEventNextEventId = (state) => {
  const nextEvent = selectedEventNextEvent(state)
  if (!nextEvent) {
    return undefined
  }
  return nextEvent.id
}

export const selectedEventPreviousEvent = (state) => {
  const thisTripData = selectedTripData(state)
  const eventIndex = selectedEventIndex(state)
  if (!thisTripData || eventIndex < 1 || !thisTripData.events[eventIndex - 1]) {
    return undefined
  }
  return thisTripData.events[eventIndex - 1]
}

export const selectedEventPreviousEventId = (state) => {
  const previousEvent = selectedEventPreviousEvent(state)
  if (!previousEvent) {
    return undefined
  }
  return previousEvent.id
}

export const selectedEventInfoDisplayed = state =>
  state.selectedEventInfoDisplayed

export const selectedEventInfoDayMediaDisplayed = state =>
  state.selectedEventInfoDayMediaDisplayed

export const selectedEventMediaId = state =>
  state.selectedEventMediaId

export const selectedEventMediaType = state =>
  state.selectedEventMediaType



// WEBPACK FOOTER //
// ./src/redux/reducers/tripsSelector.js